const translations = {
  // Nav
  nav_home: "Главная",
  nav_about: "О фонде",
  nav_plans: "Пенсионные планы",
  nav_calculator: "Калькулятор",
  nav_benefits: "Преимущества",
  nav_contact: "Контакты",
  nav_open_account: "Открыть счёт",

  // Hero
  hero_badge: "Норвежский государственный пенсионный фонд",
  hero_title_1: "Ваше финансовое",
  hero_title_2: "будущее",
  hero_title_3: "начинается сегодня",
  hero_desc: "Инвестиционные контракты с гарантированной доходностью от 3% до 198%. Стабильные пенсионные выплаты и дивидендный доход каждый месяц.",
  hero_cta_calc: "Рассчитать пенсию",
  hero_cta_learn: "Узнать больше",
  hero_stat_assets: "Активы под управлением",
  hero_stat_companies: "Компаний в портфеле",
  hero_stat_countries: "Стран инвестирования",
  hero_stat_years: "Лет опыта",

  // About
  about_badge: "О фонде",
  about_title_1: "Крупнейший в мире суверенный",
  about_title_2: "пенсионный фонд",
  about_desc1: "Government Pension Fund Global (GPFG) — государственный пенсионный фонд Норвегии, основанный в 1990 году. Фонд управляет активами на сумму более €1,4 трлн, что делает его крупнейшим суверенным фондом благосостояния в мире.",
  about_desc2: "Фонд инвестирует в акции более 9 000 компаний в 70 странах, обеспечивая максимальную диверсификацию и защиту капитала. Каждый инвестиционный контракт гарантирован норвежским государством.",
  about_feat1: "Рейтинг Moody's AAA",
  about_feat2: "Министерство финансов Норвегии",
  about_feat3: "Инвестиции в 70 странах",
  about_feat4: "100% государственная гарантия",
  about_cta: "Выбрать план",
  about_years: "лет надёжной работы",

  // Plans
  plans_badge: "Инвестиционные контракты",
  plans_title: "Выберите пенсионный план",
  plans_desc: "Три уровня инвестиционных контрактов с гарантированной доходностью. Чем выше сумма — тем больше дивидендный доход.",
  plans_badge1: "Базовый уровень",
  plans_badge2: "Популярный выбор",
  plans_badge3: "Максимальная выгода",
  plans_tier1: "Стартовый",
  plans_tier2: "Оптимальный",
  plans_tier3: "Премиум",
  plans_contract: "инвестиционный контракт",
  plans_per_month: "в месяц",
  plans_monthly: "Ежемесячно:",
  plans_sign: "Подписать контракт",
  plans_feat1_1: "3–5% в месяц",
  plans_feat1_2: "Ежемесячные выплаты",
  plans_feat1_3: "Государственная гарантия",
  plans_feat1_4: "Онлайн-кабинет инвестора",
  plans_feat1_5: "Бесплатная консультация",
  plans_feat2_1: "До 103% в месяц",
  plans_feat2_2: "Повышенные дивиденды",
  plans_feat2_3: "Приоритетное обслуживание",
  plans_feat2_4: "Персональный менеджер",
  plans_feat2_5: "Реинвестирование прибыли",
  plans_feat3_1: "157–198% в месяц",
  plans_feat3_2: "VIP-обслуживание",
  plans_feat3_3: "Персональный менеджер",
  plans_feat3_4: "Квартальные бонусы",
  plans_feat3_5: "Эксклюзивные инвестиции",
  plans_disclaimer: "* Доходность основана на исторических данных фонда. Инвестиции защищены государственной гарантией Норвегии.",

  // Calculator
  calc_badge: "Калькулятор доходности",
  calc_title: "Рассчитайте вашу будущую пенсию",
  calc_promo: "От <1>€3 000</1> — уже <2>103%</2> в месяц!",
  calc_promo_pre: "От",
  calc_promo_mid: "— уже",
  calc_promo_post: "в месяц!",
  calc_amount_label: "Сумма контракта",
  calc_tier1_label: "3–5%",
  calc_tier1_sub: "до €3 000",
  calc_tier2_label: "103% 🔥",
  calc_tier2_sub: "от €3 000",
  calc_tier3_label: "157%",
  calc_tier3_sub: "от €5 000",
  calc_tier4_label: "198%",
  calc_tier4_sub: "€10 000",
  calc_return_label: "Доходность по плану",
  calc_per_year: "в месяц",
  calc_monthly_label: "Ежемесячная пенсия",
  calc_monthly_sub: "в месяц",
  calc_dividend_label: "Годовой дивидендный доход",
  calc_dividend_sub: "в год",
  calc_tip: "От <1>€3 000</1> ваша доходность составляет <2>103% в месяц</2>. При €10 000 — максимум <3>198%</3>.",
  calc_cta: "Подписать инвестиционный контракт",

  // Benefits
  benefits_badge: "Почему выбирают нас",
  benefits_title: "Преимущества Government Pension Fund Global",
  benefits_desc: "Более 35 лет мы обеспечиваем стабильный пенсионный и дивидендный доход для тысяч инвесторов по всему миру",
  benefits_adv1_title: "Государственная гарантия",
  benefits_adv1_desc: "Ваши инвестиции защищены государством. Фонд работает под надзором Министерства финансов Норвегии с 1990 года.",
  benefits_adv2_title: "Стабильный рост",
  benefits_adv2_desc: "Средняя годовая доходность фонда за последние 25 лет превышает 6%. Ваш капитал работает на вас.",
  benefits_adv3_title: "Дивидендный доход",
  benefits_adv3_desc: "Получайте ежемесячные дивидендные выплаты прямо на ваш счёт. Прозрачная отчётность и полный контроль.",
  benefits_adv4_title: "Глобальная диверсификация",
  benefits_adv4_desc: "Портфель включает акции более 9 000 компаний в 70 странах. Максимальная защита от рисков.",
  benefits_adv5_title: "Персональный подход",
  benefits_adv5_desc: "Каждый клиент получает персонального менеджера и индивидуальный инвестиционный план.",
  benefits_adv6_title: "Гибкие условия",
  benefits_adv6_desc: "Выберите срок контракта от 5 до 30 лет. Досрочный выход без штрафов.",
  benefits_passive_badge: "Пассивный доход",
  benefits_passive_title1: "Получайте стабильные",
  benefits_passive_title2: "дивиденды ежемесячно",
  benefits_passive_desc1: "Дивидендный доход — это ваш пассивный заработок от инвестиций в крупнейшие мировые компании. Фонд распределяет прибыль среди инвесторов каждый месяц, обеспечивая стабильный денежный поток.",
  benefits_passive_desc2: "Вы можете реинвестировать дивиденды для ускоренного роста капитала или получать их на счёт — выбор за вами.",
  benefits_li1: "Выплаты каждый месяц без задержек",
  benefits_li2: "Реинвестирование прибыли для роста",
  benefits_li3: "Прозрачная онлайн-отчётность",
  benefits_li4: "Налоговая оптимизация для инвесторов",
  benefits_stat1: "Максимальная ежемесячная выплата",
  benefits_stat2: "Максимальная доходность",
  benefits_stat3: "Выплат в год",
  benefits_stat4: "Государственная гарантия",
  benefits_reviews_title: "Истории наших клиентов",
  benefits_reviews_sub: "Реальные отзывы инвесторов Government Pension Fund Global",
  benefits_t1_text: "«Я вложил €10 000 три года назад и теперь получаю стабильные €4 200 каждый месяц. Это изменило мою жизнь!»",
  benefits_t1_name: "Анна Мюллер",
  benefits_t1_meta: "67 · Берлин · Премиум",
  benefits_t2_text: "«Government Pension Fund Global — это надёжность и стабильность. Мой дивидендный доход растёт каждый год.»",
  benefits_t2_name: "Клаус Берг",
  benefits_t2_meta: "71 · Осло · Оптимальный",
  benefits_t3_text: "«Начал со стартового плана, перешёл на премиум через год. Теперь путешествую по всему миру на пенсионные выплаты.»",
  benefits_t3_name: "Мария Хансен",
  benefits_t3_meta: "64 · Копенгаген · Премиум",

  // Contact
  contact_badge: "Свяжитесь с нами",
  contact_title1: "Начните получать",
  contact_title2: "пенсионный доход сегодня",
  contact_desc: "Оставьте заявку, и наш персональный менеджер свяжется с вами в течение 24 часов. Мы поможем выбрать оптимальный инвестиционный контракт и ответим на все вопросы.",
  contact_phone_label: "Телефон",
  contact_email_label: "Email",
  contact_address_label: "Адрес",
  contact_hours_label: "Часы работы",
  contact_hours_val: "Пн–Пт: 09:00–18:00 (CET)",
  contact_form_title: "Оставить заявку",
  contact_fname: "Имя",
  contact_fname_ph: "Ваше имя",
  contact_lname: "Фамилия",
  contact_lname_ph: "Ваша фамилия",
  contact_email: "Email",
  contact_phone: "Телефон",
  contact_plan: "Интересующий план",
  contact_plan_ph: "Выберите план",
  contact_plan1: "Стартовый — €3 000 (3–5%)",
  contact_plan2: "Оптимальный — €5 000 (103%)",
  contact_plan3: "Премиум — €10 000 (157–198%)",
  contact_msg: "Сообщение",
  contact_msg_ph: "Ваши вопросы или пожелания...",
  contact_submit: "Отправить заявку",
  contact_submitting: "Отправка...",
  contact_success_title: "Заявка отправлена!",
  contact_success_desc: "Наш менеджер свяжется с вами в течение 24 часов.",
  contact_privacy: "Нажимая кнопку, вы соглашаетесь с политикой конфиденциальности",

  // Footer
  footer_cta_title: "Готовы начать инвестировать?",
  footer_cta_desc: "Откройте инвестиционный контракт сегодня и начните получать пенсионный доход",
  footer_cta_btn: "Открыть счёт",
  footer_about_desc: "Крупнейший в мире суверенный пенсионный фонд. Надёжные инвестиции с государственной гарантией.",
  footer_col1: "О фонде",
  footer_col1_l1: "История фонда",
  footer_col1_l2: "Команда управления",
  footer_col1_l3: "Годовые отчёты",
  footer_col1_l4: "Пресс-центр",
  footer_col2: "Инвестиции",
  footer_col2_l1: "Пенсионные планы",
  footer_col2_l2: "Калькулятор доходности",
  footer_col2_l3: "Дивидендный доход",
  footer_col2_l4: "Портфель фонда",
  footer_col3: "Поддержка",
  footer_col3_l1: "FAQ",
  footer_col3_l2: "Личный кабинет",
  footer_col3_l3: "Связаться с нами",
  footer_col3_l4: "Документы",
  footer_col4: "Правовая информация",
  footer_col4_l1: "Политика конфиденциальности",
  footer_col4_l2: "Условия использования",
  footer_col4_l3: "Лицензии",
  footer_col4_l4: "Раскрытие информации",
  footer_copy: "© 2026 Government Pension Fund Global. Все права защищены.",
  footer_disclaimer: "Инвестиции сопряжены с рисками. Прошлые результаты не гарантируют будущей доходности. Фонд находится под надзором Министерства финансов Норвегии.",

  // Live notification
  notif_received: "получил(а)",
  notif_plan: "Премиум",

  // Plans tiers in calculator
  calc_plan_starter: "Стартовый",
  calc_plan_optimal: "Оптимальный",
  calc_plan_advanced: "Продвинутый",
  calc_plan_premium: "Премиум",
};

export default translations;
